import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiOneHalfImage' })(
  ({ brandType, type, breakpoints, typography }) => ({
    container: {
      marginTop: typography.pxToRem(0),
    },
    section: {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      height: typography.pxToRem(600),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        height: typography.pxToRem(300),
      },
    },
    textContainer: {
      display: 'flow-root',
      paddingLeft: typography.pxToRem(46),
      paddingRight: typography.pxToRem(30),
      paddingTop: typography.pxToRem(78),
      height: typography.pxToRem(600),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(20),
        alignItems: 'unset',
        paddingTop: typography.pxToRem(32),
        paddingBottom: typography.pxToRem(48),
        height: 'auto',
      },
    },
    title: {
      ...type['44_medium'],
      textWrap: 'pretty',
      paddingBottom: typography.pxToRem(30),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...brandType['heading-xxs'],
      },
    },
    subtitle: {
      ...type['28_medium'],
      textWrap: 'pretty',
      paddingBottom: typography.pxToRem(30),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['24_medium'],
      },
    },
    body: {
      ...type['20_regular'],
      paddingBottom: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
      },
    },
    buttom: {
      paddingBottom: typography.pxToRem(20),
      marginTop: 10,
    },
  })
);

export default useStyles;
